import makeUrl from './services/mini/makeUrl';
import history from './history';

const URL_PREFIX = process.env.URL_PREFIX;

export const routePrefix = (pathname?) => {

       const url = pathname || window.location.pathname;

       if (URL_PREFIX === '') return '';

       // support both browser and react-router pathname format
       if (url.indexOf(`${URL_PREFIX}`) === 0 || url.indexOf(`${URL_PREFIX}`) === 1) {
              return `/${URL_PREFIX}`;
       }

       return '';
};

export const getCurrentRoute = (pathname?) => {
       let url = pathname || history.getCurrentLocation().pathname;

       const urlPrefix = routePrefix(url).replace('/', '');

       if (urlPrefix) {
              url = url.replace(`${urlPrefix}/`, '');
       }

       return url;
}

export const routeInfo = {
       index: {
              path: `${routePrefix()}/`,
              url: () => routeInfo.index.path
       },
       projects: {
              path: `${routePrefix()}/projects`,
              url: () => routeInfo.projects.path
       },
       project: {
              path: `${routePrefix()}/projects/:projectName`,
              url: (projectName) => `${routePrefix()}/projects/${makeUrl(projectName)}`
       },
       projectScripts: {
              rootPath: `${routePrefix()}/projects/:projectName/scripts`,
              path: `${routePrefix()}/projects/:projectName/scripts/:scriptName`,
              url: (projectName, scriptName) => {
                     return `${routePrefix()}/projects/${makeUrl(projectName)}/scripts/${makeUrl(scriptName || 'root')}`;
              }
       },
       projectTests: {
              rootPath: `${routePrefix()}/projects/:projectName/scripts/:scriptName/tests`,
              path: `${routePrefix()}/projects/:projectName/scripts/:scriptName/tests/:conversationName`,
              url: (projectName, scriptName, conversationName?) => {
                     return `${routePrefix()}/projects/${makeUrl(projectName)}/scripts/${makeUrl(scriptName || 'root')}/tests/${makeUrl(conversationName || 'root')}`;
              }
       },
       embed: {
              path: `${routePrefix()}/projects/:projectName/embed/:scriptName`,
              url: (projectName, scriptName) => `${routePrefix()}/projects/${makeUrl(projectName)}/embed/${makeUrl(scriptName || 'root')}`
       },
       diff: {
              path: `${routePrefix()}/projects/:projectName/diff/:scriptName`,
              url: (projectName, scriptName) => `${routePrefix()}/projects/${makeUrl(projectName)}/diff/${makeUrl(scriptName)}`
       },
       corpus: {
              path: `${routePrefix()}/projects/:projectName/scripts/:scriptName/corpus/:corpusId/:corpusTitle`,
              url: (projectName, scriptName, corpusId, corpusTitle) => `${routePrefix()}/projects/${makeUrl(projectName)}/scripts/${makeUrl(scriptName || 'root')}/corpus/${makeUrl(corpusId)}/${makeUrl(corpusTitle)}`
       },
       corpuses: {
              path: `${routePrefix()}/projects/:projectName/scripts/:scriptName/corpuses/:corpusLine`,
              url: (projectName, scriptName, corpusLine) => `${routePrefix()}/projects/${makeUrl(projectName)}/scripts/${makeUrl(scriptName || 'root')}/corpuses/${corpusLine}`
       },
       analytics: {
              path: `${routePrefix()}/projects/:projectName/analytics/:scriptName`,
              url: (projectName, scriptName?) => `${routePrefix()}/projects/${makeUrl(projectName)}/analytics/${makeUrl(scriptName || 'root')}`
       },
       inviteFriends: {
              path: `${routePrefix()}/invite-friends`,
              url: () => routeInfo.inviteFriends.path
       },
       plans: {
              path: `${routePrefix()}/plans`,
              url: () => routeInfo.plans.path
       },
       organization: {
              path: `${routePrefix()}/organization`,
              url: () => routeInfo.organization.path
       },
       profile: {
              path: `${routePrefix()}/profile`,
              url: () => `${routeInfo.profile.path}`,
       },
       billing: {
              path: `${routePrefix()}/billing`,
              url: () => `${routeInfo.billing.path}`,
       },
       login: {
              path: `${routePrefix()}/login`,
              url: () => `${routeInfo.login.path}`,
       },
       githubOauth: {
              path: `${routePrefix()}/githubOauth`,
              url: () => `${routeInfo.githubOauth.path}`,
       },
       register: {
              path: `${routePrefix()}/register`,
              url: () => `${routeInfo.register.path}`
       },
       loginWithGithub: {
              path: `${routePrefix()}/loginWithGithub`,
              url: () => `${routeInfo.loginWithGithub.path}`
       },
       oops: {
              path: `${routePrefix()}/oops`,
              url: () => `${routeInfo.oops.path}`,
       },
       planVerification: {
              path: `${routePrefix()}/planVerification`,
              url: () => `${routeInfo.planVerification.path}`,
       },
       orgMemberVerification: {
              path: `${routePrefix()}/orgMemberVerification`,
              url: () => `${routeInfo.orgMemberVerification.path}`,
       },
       oauth: {
              path: `${routePrefix()}/oauth`,
              url: () => `${routeInfo.oauth.path}`,
       },
       loginVerify: {
              path: `${routePrefix()}/login/verify/:hex/:email`,
       },
       loginWithEmail: {
              path: `${routePrefix()}/login/:email`,
              url: (email) => `${routePrefix()}/login/${encodeURIComponent(email)}`,
       },
       loginWithEmailAndHex: {
              path: `${routePrefix()}/login/:hex/:email`,
       },
       registerWithEmail: {
              path: `${routePrefix()}/register/:email`,
              url: (email) => `${routePrefix()}/register/${encodeURIComponent(email)}`,
       },
       registered: {
              path: `${routePrefix()}/registered`,
              url: () => `${routeInfo.registered.path}`,
       },
       verificationEmailSent: {
              path: `${routePrefix()}/verificationEmailSent`,
              url: () => `${routeInfo.verificationEmailSent.path}`,
       },
       restorePassword: {
              path: `${routePrefix()}/restorePassword`,
              url: (email: string) => `${routeInfo.restorePassword.path}/${encodeURIComponent(email)}`,
       },
       restorePasswordWithEmail: {
              path: `${routePrefix()}/restorePassword/:email`,
       },
       recoveryWithEmailAnsHex: {
              path: `${routePrefix()}/recovery/:hex/:email`,
       },
};